export const AUTH_STORAGE_KEY = 'ReactStorage__Authentication';
export const AUTH_SESSION_ENDED_EVENT = 'kc:auth:session-ended';
